import { useFeaturedReviews } from '../../hooks/useFeaturedReviews';
import { useDragScroll } from '../../hooks/useDragScroll';
import { StarRating } from '../ui/StarRating';
import { StoreFeaturedReview } from '../../models';
import { SectionHeading } from './SectionHeading';

function ReviewCard({ review }: { review: StoreFeaturedReview }) {
  return (
    <div className="w-72 sm:w-80 shrink-0 snap-start bg-white rounded-2xl border border-champagne-dark shadow-sm p-5 flex flex-col">
      <StarRating value={review.rating} size="sm" />
      <p className="text-sm text-text-medium leading-relaxed mt-3 flex-1">&ldquo;{review.comment}&rdquo;</p>
      <div className="mt-4 pt-3 border-t border-champagne">
        <p className="text-sm font-semibold text-text-dark">
          {review.reviewerFirstName}
          {review.reviewerCity && <span className="text-text-light font-normal"> — {review.reviewerCity}</span>}
        </p>
        {review.productName && (
          <span className="inline-block mt-1.5 text-[11px] font-medium text-chocolate-dark bg-champagne px-2 py-0.5 rounded-full">
            {review.productName}
          </span>
        )}
      </div>
    </div>
  );
}

export function SocialProof() {
  const { reviews, isLoading, error, isEmpty } = useFeaturedReviews();
  const {
    ref: scrollRef,
    onMouseDown,
    onMouseMove,
    onMouseUp,
    onMouseLeave,
    onMouseEnter,
    onTouchStart,
    onTouchEnd,
    onClickCapture,
  } = useDragScroll<HTMLDivElement>();

  if (isLoading || error || isEmpty) return null;

  return (
    <div className="max-w-[1600px] mx-auto px-4 pt-10">
      <SectionHeading title="O que nossas clientes dizem" />

      <div
        ref={scrollRef}
        className="flex gap-4 overflow-x-auto no-scrollbar pb-2 -mx-4 px-4 scroll-px-4 md:mx-0 md:px-0 md:scroll-px-0 [@media(pointer:coarse)]:[scroll-snap-type:x_proximity] [@media(pointer:fine)]:cursor-grab [@media(pointer:fine)]:select-none [scroll-behavior:auto]"
        onMouseDown={onMouseDown}
        onMouseMove={onMouseMove}
        onMouseUp={onMouseUp}
        onMouseLeave={onMouseLeave}
        onMouseEnter={onMouseEnter}
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
        onClickCapture={onClickCapture}
      >
        {reviews.map((review) => (
          <ReviewCard key={review.id} review={review} />
        ))}
      </div>
    </div>
  );
}
